import { newId, useDataTypeFileActions } from "../../../features/data-types"
import { DataType, TableName } from "../../../tables"
import { define } from "../../../utils/typeUtils"
import { useSystemStateHooks } from "../../system"
import { SaleOrder } from "../state/types"
import { useHoardActions } from "./hoard-actions/hoardActions"
import { Settings, SettingsDataType, SettingsModule, useAdministrationActions, useSettingsLoaders } from "../../administration"

export const useSalesActions = () => {
    const stateCompanyId = useSystemStateHooks().companyId

    const settingsLoaders = useSettingsLoaders()

    const administrationActions = useAdministrationActions()
    const hoardActions = useHoardActions()
    const dataTypeFileActions = useDataTypeFileActions()

    return (paramCompanyId?: string) => {
        const companyId = define(paramCompanyId || stateCompanyId)
        const { countHoards, saveHoardWithFile } = hoardActions(companyId)
        const { saveSettings } = administrationActions(companyId)

        const saveSalesSetting = async (propName: string, value: SettingsDataType) => {
            const { findModuleSettings } = settingsLoaders(companyId)
            const settings = findModuleSettings(SettingsModule.SALES)
            const updatedSettings: Settings = settings ? {
                ...settings,
                [propName]: value
            } : {
                companyId: define(companyId),
                id: newId(),
                module: SettingsModule.SALES,
                [propName]: value
            }
            
            return await saveSettings(updatedSettings) as Settings
        }

        const saveSaleWithFile = async (
            sale: SaleOrder,
            file: File,
            fileProp = 'invoiceUrl'
        ) => {
            const { saveWithFile } = dataTypeFileActions(define(companyId))
            return saveWithFile(TableName.SALE_ORDERS, sale, fileProp as keyof DataType, file)
        }

        return {
            saveSalesSetting,
            saveSaleWithFile,
            countHoards,
            saveHoardWithFile
        }
    }
}
